import * as React from 'react';
import { useRedeemPromotion } from 'blocks/Pricing';
import PostDownloadJoyride from 'blocks/ProjectsPage/components/PostDownloadJoyride';
import Page from 'components/Page';
import SocialIconsBottomBar from 'containers/SocialIconsBottomBar';

import ProjectsPageTabs from '../../components/ProjectsPageTabs';
import { block } from '../../utils';
import ProjectsPageModalManager from '../ProjectsPageModalManager';
import useNewProjectClick from './useNewProjectClick';
import useOnProjectsPageMount from './useOnProjectsPageMount';

export type ProjectsPageProps = {};

const ProjectsPage: React.FC<ProjectsPageProps> = () => {
  useOnProjectsPageMount();
  useRedeemPromotion();

  const { onNewProjectClick } = useNewProjectClick();

  return (
    <Page className={block()} fillViewport>
      <ProjectsPageTabs onNewProjectClick={onNewProjectClick} />

      <SocialIconsBottomBar />

      <ProjectsPageModalManager />

      <PostDownloadJoyride />
    </Page>
  );
};

export default ProjectsPage;
